import get from 'lodash/get';

export const getCreatorImage = ({ collection }) => {
    let creatorImage = get(collection, ['creator', 'image', 'url']);

    if (collection.displayCreatorImageUrl) {
        creatorImage = collection.displayCreatorImageUrl;
    }

    return creatorImage;
};
